module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "calibre_pb_0"
    }
  }, [_c('p', {
    staticClass: "calibre4"
  }, [_c('a', {
    attrs: {
      "id": "Page_29",
      "title": "[29]"
    }
  })]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "CHAPTER_III"
    }
  }, [_vm._v("CHAPTER III."), _c('br', {
    staticClass: "calibre"
  }), _vm._v(" "), _c('span', {
    staticClass: "fs2"
  }, [_vm._v("THE BARON FINDS EXCITEMENT.")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("The baron got his wish.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("The Blossom Range postmaster, having wired for instructions that night, handed to Buffalo Bill in the morning an order requiring him to become one of the escort of the mail stage to leave the town that day. The post office authorities had got into quick communication with those of the war department, with that result.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Nomad chose to go with Buffalo Bill. The stage would carry the mails, even though it did not take the treasure. So that determined the matter for the scout.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("When the Wells Fargo agent asked if he could recommend a good fighting man to go with the burros that were to be taken out by Austin and Brown, the scout recommended the baron.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Ach! I am a brosbector,” said the baron, highly pleased, as he clattered down from his room in the Eagle House and paused by the desk of the clerk.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("He looked it, every inch, in spite of his girth and his pipe-stem legs. He was dressed as a miner, except that he stuck to his little fore-and-aft cap.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I haf seen enough since I gome py dhis town in,” he explained, “to seddle idt vor me. Dhere iss goldt in dhese hills; unt I am going to findt some uff idt.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Look out for road agents and Indians, then, if you git hold of any,” the clerk warned him. “Going out alone?” he asked, as a second thought.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('a', {
    attrs: {
      "id": "Page_30",
      "title": "[30]"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Not any. I tond’t peen ackvainted mit dhese hills, unt meppy I might losdt mineselluf. No; I am going oudt mit Ausdin unt Prown.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Oh, they’re going out this morning, are they? Good men! But though they’ve prospected a lot round here in the last month or so, I never knew them to strike anything worth while.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Idt iss "), _c('em', {
    staticClass: "calibre5"
  }, [_vm._v("me")]), _vm._v(" vot vill shange dheir lucks!” the baron boasted, as he went on out of the office.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Austin and Brown had their burros in the street, and were waiting for the baron. They were quiet-looking men, of the miner type, who, in a town like that, would not attract a second glance. Nor was anybody paying heed to their burros and their packed outfit, with the picks and shovels displayed prominently on top; prospectors went from the town every day, and these two men had already been out a number of times.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("All attention was being directed to the stage, ready soon to leave the stables with the United States mail, and, as was supposed, the treasure to be shipped that day by the Wells Fargo company.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("The stage was filled with armed men, who prominently displayed their hardware. On top, sitting beside the driver, were old Nomad and Buffalo Bill. The public knew now that Buffalo Bill was being sent along by the postal authorities.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("It was the general belief that when the treasure went through the cañon beyond Stag Mountain, where so many hold-ups had occurred, there would be a lively fight, if the bandits, who were known to be infesting the hills, could get enough men together to make the deadly tackle.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('a', {
    attrs: {
      "id": "Page_31",
      "title": "[31]"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("But the stage went through the cañon that day without a ripple of excitement. Not a road agent was there.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("To be sure of this, when the stage had passed beyond what was considered the danger spot it was halted, and some of the armed men went back, to poke through the bushes.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Scared ’em off with the big show of fighting men we made,” said the men, when they returned.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("It was fully two hours later when the baron, with Austin and Brown, butted into the excitement which the baron had anticipated.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("At Eagle Gap, where no trouble of any kind had ever before occurred, two men rose up beside the winding path, and began to shoot as soon as they rose. The men were masked, and they were well armed, each with a repeating rifle and a brace of revolvers.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Austin went down at the first fire, shot through the head, being killed instantly. Brown toppled, falling wounded. The baron threw himself flat on the ground, escaping that first shooting as if by a miracle; though the real reason was that Austin and Brown stopped the first bullets the bandits sent from their repeaters; and before they could fire again the baron was down, and behind a rock.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Ouch!” he squawked. “I am to pe kilt, huh!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Then he fired back.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("He apparently wounded one of the men, which stopped their rush toward him, and enabled him to take a tumble backward down the steep slope. The baron plowed a reckless furrow, which barked his skin and tore his clothing, but landed him in a rocky hollow some distance"), _c('a', {
    attrs: {
      "id": "Page_32",
      "title": "[32]"
    }
  }), _vm._v(" down, before the outlaws could get to the top of the slope and shoot at him.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Poking his head out enough to enable him to see, he blazed away again, when he saw one of the men appear; and drove the bandits back once more.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Following this, the baron crept on his hands and knees down the gulley, determining what the men were doing by the sounds they made.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Ach!” he said. “Dhis iss der vorsdt effer.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("The baron did not show himself for a while; but sat nursing his rifle, occupying a hollow into which he wedged his body, and where he was resolved to fight to the death if the outlaws followed him.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("He knew they had the advantage, being familiar with the country, and being two to one.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("When he concluded that they were not coming after him, he got out of his hole, and tried to discover what they were doing.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Then he found that they were gone.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("They had taken the burros and treasure, and had vanished.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("The place was a cut, with debouching gashes making from it in various directions, all rocky and hard as flint; so that, being unfamiliar with the location, the baron could do nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Abundant proof that they had been there was given by the grewsome sight of the dead Austin, and by the wounded man they had considered dying when they left him.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Brown had been shot through the right side, but he was still conscious. To keep them from finishing him, he had feigned death.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("When the baron gave him some stimulant from his"), _c('a', {
    attrs: {
      "id": "Page_33",
      "title": "[33]"
    }
  }), _vm._v(" pocket flask, the prospector regained enough animation to be able to talk.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Tough luck, pard!” he said. “They got Austin!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Unt der dreasure!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Yes. I didn’t see but two of ’em. If they hadn’t surprised us, we might ’a’ done something. But thar wasn’t much show, when they riz up shootin’ as they riz. If you think they’re gone, see if that bullet is still in my side, will ye?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("The baron made the examination, his rifle on the ground where he could pick it up instantly.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Der pullet vendt t’rough,” he said, when he had looked the man over. “You needt der hosbidal pooty kvick, I dell you.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I reckon I’ll never git thar, with the burros gone.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("The baron gave the man more stimulant; then plugged the wound and bandaged it as well as he could, tearing the man’s shirt into strips for the purpose.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Having done that, he stood back and looked the man over.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I dhinks maype I gan carry you,” he said. “You aind’t so heavy as me.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I don’t reckon you could do it, pard,” Brown answered.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Vale, ve dry idt, eenyhow. Uff der voundt tond’t pleed too much ve gan make idt. How many miles iss idt?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“All of three, I reckon; and rough goin’.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("In spite of his unpromising physical appearance, the baron was strong; and he had the stuff of which heroes are made.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("He accomplished the three miles over the rough trails"), _c('a', {
    attrs: {
      "id": "Page_34",
      "title": "[34]"
    }
  }), _vm._v(" with Brown on his shoulders, and got him into the local hospital in time to save his life.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("The knowledge that the prospectors had been in charge of the treasure; that Austin was dead, Brown wounded, and the treasure gone, furnished news of a sufficiently exciting kind to fill all the public places of Blossom Range with crowds.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“A Dutchman’s luck!” was the universal verdict, when reference to the baron’s escape was made. “You can’t kill a Dutchman.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Buffalo Bill talked the matter over with his pards, in the seclusion of his room at the Eagle House, while a delegation of the townspeople had gone out to Eagle Gap to bring in the body of the dead prospector, and poke round out there for whatever they could find of interest concerning the daring desperadoes who had made the attack.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Thar is one shore thing,” said old Nomad, humped up in his chair and smoking his pipe; “ther chaps what made ther tackle had information o’ the hull bizness.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Unt der kvestion iss,” the baron added, “how didt dey knowed idt?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Somebody leaked the information,” said Buffalo Bill.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Which means,” said Nomad, “thet either ther express agent, ther fellers in ther post office, er at the stage stables, aire inter ther thing deep. Et was ter be kept so clost, ye know, thet nobudy c’d ketch on.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Vot uff Yuniper Yoe?” asked the baron; “I am t’inking uff him!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Er, waugh! Yer mean he might er been ther one ter give ther snap away?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Dot iss yoost vot I am saying.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('a', {
    attrs: {
      "id": "Page_35",
      "title": "[35]"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“But—he had ten thousand dollars’ wuth o’ stuff in them burro packs! Would he tip off ther road agents, ter git his own wealth? Et don’t hardly look like it, pard.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I aind’t saying dot he did idt,” the baron admitted. “I am yoost asking some kvestions.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Right now, we are pretty much in the dark,” the scout admitted.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Ve ar-re all oop der sdump!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“They are giving you a lot of praise round the town, baron,” Buffalo Bill told him. “They say that you put up a nervy fight.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Vale,” said the baron, unmoved, sucking at his long-stemmed pipe, “dey tond’t know only yoost vot I toldt ’em.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Brown says that you put up a good fight, and that you wounded one of the outlaws.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I seen der willain reel pack unt shake, ven I shodt at him; budt he ditn’t vall town.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“And you brought Brown in on your shoulders.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Uff course! Vot else couldt I do? Dot aind’t no pravery, idt vos yoost muscle; unt idt took a heab uff idt, I dell you. He veigh apoudt two dons, pefore I gidt him here py der hospidal in. Yaw!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“What makes you think et may be Juniper Joe leaked information?” Nomad asked, coming back to the subject that interested hint.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I haf no reason; idt iss yoost vot Puffalo Pill somedime calls insdinedtiveness. I seem to schmell idt in der admosphere.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“That ain’t no reason!” the trapper sniffed.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“You ar-re righdt; idt aind’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('a', {
    attrs: {
      "id": "Page_36",
      "title": "[36]"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Speaking of Juniper Joe,” remarked Buffalo Bill, “this morning early I saw his wife downtown; I heard her say she was out making calls on the ladies, as she wanted to get acquainted with them as soon as she could.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“It wouldn’t take her long,” Nomad sniffed, “fer thar ain’t many in this hamlet.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I noticed that she paid a visit to the show girls who are stopping at the Casino; the bills outside announce that they’ve got a playlet on the boards there, called ‘Grandpa’s Holiday’.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Nomad snickered.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Whatever would she want to call on them song birds fer?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I don’t know, except through curiosity, and because there are so few women in the town. I was still outside when she came down, and she was talking with one of them at the foot of the stairs just before she came away. I took a look at the girl—a thing with a head of hair like a Circassian Beauty; on asking one of the assistants who she was, I was informed that her name is Vera Bright.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Waugh!” Nomad gulped, smothering a snicker. “Thar’s a name fer ye!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I don’t suppose it meant anything at all,” remarked the scout, as if musing over it.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Prob’ly not. Them show gals is frum ther East, I reckon, and likely thet accounted fer Mrs. Joe payin’ ’em a visit.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("They came back to the subject uppermost in their minds—the question of who could have leaked information to the road agents.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('a', {
    attrs: {
      "id": "Page_37",
      "title": "[37]"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("When they had threshed through it again, and made nothing of it, Buffalo Bill prepared to go down to the Wells Fargo office.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Do yer reckon,” said Nomad, as he and the baron arose to accompany the scout, “that this hyar Jackson Dane, what calls hisself a Frisco detective, could be mixed inter ther thing? Recklect thet Juniper Joe says he is shore Tim Benson.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I’m not forgetting what Juniper Joe said about him.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“But what does yer think?” the trapper persisted.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“There I am stalled again. It seems that we are called on to suspect everybody: the express agent, the post office people, the stage hands, and driver, Juniper Joe, and this alleged detective. Perhaps we’ll even add to the list as we go along.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Mebby we’ll ring in the Casino ladies,” suggested the trapper with a grin.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“It wouldn’t surprise me if we did.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Waugh!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Vale, dot vouldt furnish some excidemendt!” protested the German.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I should think, Schnitz, thet ye’d had ernough fer one day!” Nomad growled.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I am a hawg for excidemendt,” the baron admitted.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Down at the Wells Fargo office they found Juniper Joe, with a number of other men, most of them shippers of the treasure taken by the road agents. They had been filing claims for repayment by the company.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I cain’t afford to lose that ten thousand dollars, y’ know,” the scout heard Juniper Joe remarking, as he entered the door. “It’s a lot o’ money; I paid the company"), _c('a', {
    attrs: {
      "id": "Page_38",
      "title": "[38]"
    }
  }), _vm._v(" fer safe transportation, and I expects it to make good.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Some of the other claimants said much the same thing.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("The office was crowded, for, in addition to these men, a lot of loafers were hanging round, their ears open for news and gossip.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Having entered, Buffalo Bill and his pards stood by the door, almost at first unnoticed, listening to the talk, trying to get a “line” on something.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("The agent seemed flustered and nervous; apparently, he did not know what the powers who were over him would think of his action in sending the treasure across the mountain with the prospectors. He even admitted that he expected a “call down,” as he had exceeded his authority in doing it.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I suppose I ought to have let her gone by the stage,” he said. “Likely if I had the stage would have been held up, and the stuff taken, and instead of one dead man and another in the hospital, the cañon down there beyond Stag Mountain would have been full of them.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“So, it’s your opinion that somebody who knew the secret, leaked?” said Buffalo Bill, speaking up now, to note the effect.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Oh! you’re here?” said the agent.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("To the scout, perhaps unduly suspicious just then, it seemed an unfortunate remark, as he was sure that the agent had seen him when he entered with his pards.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“What is "), _c('em', {
    staticClass: "calibre5"
  }, [_vm._v("your")]), _vm._v(" opinion?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Somebody blabbed, of course! But I hope you don’t think "), _c('em', {
    staticClass: "calibre5"
  }, [_vm._v("I")]), _vm._v(" did it.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('a', {
    attrs: {
      "id": "Page_39",
      "title": "[39]"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“It’s an uncalled-for statement,” said the scout. “I’m not accusing anybody—simply asking questions.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Well, I don’t know anything about it! About all I know right now is that it puts me in a hole, and I’ll likely lose my job. Why, there was more than fifty thousand dollars’ worth of stuff in those bags the burros carried!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“So I knew.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“And, of course, the Wells Fargo company air going to make a hot time about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I think they ought to.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("The people in the room, loafers and all, were staring at the tall scout.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“It don’t make any difference to me about that,” spoke up Juniper Joe. “I surrendered my stuff into your hands; and, of course, I’m goin’ to see that the company makes good the loss; that’s all. You’d do the same, if me.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“But you forget that it was "), _c('em', {
    staticClass: "calibre5"
  }, [_vm._v("you")]), _vm._v(" who suggested the plan of sendin’ it out with them prospectors!” the agent shot at him.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I thought it was a good scheme; ’twould have been, if somebody hadn’t been too free with his mouth. I ain’t sayin’ who it was. But somebody on the inside hustled the news to the road agents. That ain’t my fault; and my scheme cain’t be blamed fer it.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Oh, well! you’ve put in your claim, and that settles it!” the agent snapped back.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“It don’t settle it until I see the company’s money!” Juniper Joe told him; then went out of the office.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("When Buffalo Bill and his pards left, after a talk with the agent, they were no wiser then when they went.")]), _vm._v(" "), _c('hr', {
    staticClass: "chap2"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5c71e0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0006.vue
// module id = 72
// module chunks = 0